import { CodedProperty } from "sprint-common-web";

import { OnPremOrderStatus } from "../../types/OnPremOrderStatus";
import { OrderStatus } from "../../types/OrderStatus";

export interface OrderAuditItem {
    id: string;
    updatedBy: string;
    updatedDate: string;
    statusFrom?: OnPremOrderStatus | OrderStatus;
    statusTo?: OnPremOrderStatus | OrderStatus;
    video?: AssetAvailabilityAction;
    soundtracks?: ChangeAssetAvailability[];
    subtitles?: (ChangeAssetAvailability | ChangeSubtitle)[];
    filename?: ChangeValue;
    materialSpecification?: MaterialSpecification;
    deliveryInfo?: DeliveryInfo;
}

export interface ChangeValue<T = string> {
    from?: T;
    to?: T;
}

export enum AssetAvailabilityAction {
    Added = 1,
    Removed = 2
}

export interface MaterialSpecification {
    encodingFormat?: ChangeValue;
    aspectRatio?: ChangeValue;
    bitRate?: ChangeValue;
    resolution?: ChangeValue;
}

export interface DeliveryInfo {
    dueDate?: ChangeValue;
    deliveryTo?: ChangeValue;
    deliveryDetails?: ChangeValue;
}

export interface ChangeAssetAvailability {
    action: AssetAvailabilityAction;
    language: CodedProperty;
}

export interface ChangeSubtitle {
    filename: ChangeValue;
    language: CodedProperty;
}

export const isStatusChangeItem = (item: OrderAuditItem): boolean => {
    return !!item.statusFrom;
};

export const isMaterialSpecificationChangeItem = (item: OrderAuditItem): boolean => {
    return !!item.materialSpecification;
};

export const isFilenameChangeItem = (item: OrderAuditItem): boolean => {
    return !!item.filename;
};

export const isDeliveryInfoChangeItem = (item: OrderAuditItem): boolean => {
    return !!item.deliveryInfo;
};

export const isAssetChangeItem = (item: OrderAuditItem): boolean => {
    return !!item.video || !!item.soundtracks?.length || !!item.subtitles?.length;
};
